import { getRelativeLocaleUrl } from "astro:i18n";

import { useTranslations } from "@/i18n/utils";

import { useCurrentBreakpoint } from "@/hooks/useCurrentBreakpoint";

import Button from "@/components/shared/buttons/button";

export function JoinButton({ lang }: { lang: "en" | "es" }) {
  const translate = useTranslations(lang);
  const breakpoint = useCurrentBreakpoint();
  const mobile = breakpoint === "xs" || breakpoint === "sm";

  const HOME_URL = getRelativeLocaleUrl(`${lang}`, "");

  return (
    <a href={HOME_URL}>
      <Button
        buttonType="tertiary"
        color="white"
        label={translate("publicProfile.button.discover")}
        size={mobile ? "sm" : "base"}
      />
    </a>
  );
}
